// src/utils/parseOptionsData.js
export const parseOptionsData = (data) => {
    if (!data || !data.length) {
        return null
    }

    // Extract and parse JSON data from the response
    const parseJsonData = (jsonData) => {
        try {
            return JSON.parse(jsonData)
        } catch (error) {
            console.error('Error parsing JSON data:', error)
            return []
        }
    }

    const employeeTypes = parseJsonData(data[0].JSONData1).map(item => item.EmployeeType)
    const designations = parseJsonData(data[0].JSONData2).map(item => item.Designation)
    const departments = parseJsonData(data[0].JSONData3).map(item => item.Department)

    return {
        employeeTypes,
        designations,
        departments,
    }
}
